import { render, staticRenderFns } from "./error-500.vue?vue&type=template&id=246f537c&"
import script from "./error-500.vue?vue&type=script&lang=ts&"
export * from "./error-500.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports